import React from 'react';
import { AlertIcon } from '../../assets/imageAssets';

const LimitReachedModal = ({modalData}) => {
    return (
        <>
            <div className="modal-body">
                <div className='icon error'>
                    <img src={AlertIcon} alt="Alert Icon" />
                </div>
                <h2 className='mb-8'>Weekly Limit Reached</h2>
                <p className='mb-24'>You’ve reached your weekly quiz <strong>3/3</strong> limit. Upgrade to create unlimited quizzes.</p>
                <button className='primary-button'>Upgrade Now</button>
            </div>
        </>
    );
}

export default LimitReachedModal;